import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { priceTransform } from '@vsf-enterprise/commercetools';
import { useCart } from '~/composables/useCart';
import { useUser } from '~/composables/_next/useUser';
import { useCartPreview } from '~/composables/useCheckout/modules/useCartPreview';
import { useShippingMethods } from '~/composables/useShippingMethods';
import FormatPrice from '~/components/Atoms/FormatPrice.vue';
export default defineComponent({
  name: 'CartSummary',
  components: {
    FormatPrice: FormatPrice
  },
  setup: function setup() {
    var _useCart = useCart(),
      cart = _useCart.cart;
    var _useCartPreview = useCartPreview(),
      discountedSubtotal = _useCartPreview.discountedSubtotal;
    var _useUser = useUser(),
      isIntracomGroup = _useUser.isIntracomGroup;
    var _useShippingMethods = useShippingMethods(),
      shippingMethods = _useShippingMethods.shippingMethods;
    var getPrice = function getPrice(value) {
      var _cart$value, _cart$value$totalPric;
      return priceTransform(value, ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : (_cart$value$totalPric = _cart$value.totalPrice) === null || _cart$value$totalPric === void 0 ? void 0 : _cart$value$totalPric.currencyCode) || null);
    };
    function isShippable(lineItems) {
      return lineItems.some(function (lineItem) {
        if (lineItem.custom && lineItem.custom.customFieldsRaw) {
          return !lineItem.custom.customFieldsRaw.some(function (field) {
            return field.name === 'booking-id';
          });
        }
        return true;
      });
    }

    /**
     * Calculates and returns the price of the cheapest shipping method among all available options.
     * If the free shipping threshold is reached, the function returns 0 and displays 'free'.
     * @returns {number} The price of the cheapest shipping method, or 0 if the free shipping threshold is reached.
     */
    var shippingTotal = computed(function () {
      var _shippingMethods$valu;
      if (isShippable(cart.value.lineItems) && ((_shippingMethods$valu = shippingMethods.value) === null || _shippingMethods$valu === void 0 ? void 0 : _shippingMethods$valu.length) > 0) {
        var lowestPrice = shippingMethods.value.filter(function (method) {
          return method.key !== 'store-pick-up';
        }).reduce(function (lowest, method) {
          return method.zoneRates.reduce(function (currentLowest, zoneRate) {
            return zoneRate.shippingRates.reduce(function (zoneLowest, rate) {
              var _rate$freeAbove, _rate$price;
              if (!rate.isMatching) return zoneLowest;
              var freeAbovePrice = (rate === null || rate === void 0 ? void 0 : (_rate$freeAbove = rate.freeAbove) === null || _rate$freeAbove === void 0 ? void 0 : _rate$freeAbove.centAmount) || Infinity;
              var shippingRatePrice = ((_rate$price = rate.price) === null || _rate$price === void 0 ? void 0 : _rate$price.centAmount) || 0;
              var effectiveShippingPrice = discountedSubtotal.value * 100 >= freeAbovePrice ? 0 : shippingRatePrice;
              return Math.min(zoneLowest, effectiveShippingPrice);
            }, currentLowest);
          }, lowest);
        }, Infinity);
        return lowestPrice === Infinity ? null : lowestPrice / 100;
      }
      return null;
    });
    return {
      getPrice: getPrice,
      isIntracomGroup: isIntracomGroup,
      shippingTotal: shippingTotal,
      discountedSubtotal: discountedSubtotal
    };
  }
});